




































































import { ref, defineComponent, computed } from "@vue/composition-api";
import {
  isMobile,
  windowWidth
} from "@/ts/functions/composition/displayHelpers";
import PlaceModel from "@/ts/models/placeClass";
import ImageModel from "@/ts/models/imageClass";
import TagsInCard from "@c/molecules/card/TagsInCard.vue";

export default defineComponent({
  name: "PlaceCard",

  components: {
    TagsInCard
  },

  props: {
    place: {
      type: PlaceModel,
      default: {}
    }
  },

  setup(props: any, { root }: any) {
    const winWidth = windowWidth(root);

    const mobile = isMobile(root);

    var image: any = computed(() => {
      if (props.place && props.place.image) {
        return props.place.image;
      } else {
        return new ImageModel();
      }
    });

    return {
      winWidth,
      mobile,
      image
    };
  }
});
